import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

// Assume login_user_locally is a helper function to store user data locally
import { login_user_locally } from "../services/auth"; // Adjust the path
import { getAPIURL } from "../services/helper";
import Loader from "../Layout/Loader";

const LoginByToken = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const api_url = getAPIURL();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token") || null;
    const red = params.get("red") || null;

    if (token) {
      // API call to validate token and login
      const loginByToken = async () => {
        try {
          // Make the API call with the token
          const { data } = await axios.post(`${api_url}/login-by-token`, {
            token,
          });

          if (data.success) {
            // Call the function to log in the user locally (await ensures this completes)
            await login_user_locally(data.data);

            // Redirect the user after successful login and ensuring data is saved
            toast.success("Login successful!");
            if (red) {
              window.location.href = `/${red}`;
            } else {
              window.location.href = "/dashboard";
            }
          } else {
            toast.error("Invalid token or login failed.");
            navigate("/login"); // Redirect to login if the token is invalid
          }
        } catch (error) {
          console.error("Error during token-based login:", error);
          toast.error("Error during login. Please try again.");
          navigate("/login");
        }
      };

      // Call the login function
      loginByToken();
    } else {
      toast.error("No token provided.");
      navigate("/login");
    }
  }, [location.search, api_url, navigate]);

  return (
    <div>
      <Loader />
    </div>
  );
};

export default LoginByToken;
